<template>
    <section class="custom_quote_banner" :style="'background:'+sliderImageFullURL+'background-size: cover !important;'">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="container">
            <div class="row">
                <div class="columns col-12">
                    <div>&nbsp;</div>
                    <h1>
                        <strong> {{ sliderData.title }} </strong>
                    </h1>
                    <h2>
                        {{ sliderData.sub_title }}
                    </h2>
                    <div class="clearfix"></div>
                    <div class="r2_margin">
                        <router-link :to="{path:sliderData.button_link}" class="button success shadow d-inline-block"> {{ sliderData.button_text }} </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "SliderHome",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            sliderData: [],
            sliderImagePath: this.$api + "upload/quote_slider/",
            sliderImageFullURL: ''
        }
    },
    created() {
        document.title = "Geek Buy Back - Custom Quote";
        this.getSliderData();
    },
    methods: {
        getSliderData: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + this.$config.customQuote.getSliderURL
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.sliderData = response.data.data;
                    this.sliderImageFullURL = "#717171 url("+this.sliderImagePath+response.data.data.slider_background+") no-repeat center bottom !important;";
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        }
    }
}
</script>
